function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "other_svg__cls-1",
  d: "M66.27 117c-27.97 0-50.73-22.76-50.73-50.73s22.75-50.73 50.73-50.73S117 38.3 117 66.27 94.24 117 66.27 117zm0-96.46c-25.22 0-45.73 20.52-45.73 45.73S41.06 112 66.27 112 112 91.49 112 66.27 91.49 20.54 66.27 20.54z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "other_svg__cls-1",
  cx: 39.27,
  cy: 66.27,
  r: 6.27
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "other_svg__cls-1",
  cx: 66.27,
  cy: 66.27,
  r: 6.27
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "other_svg__cls-1",
  cx: 93.27,
  cy: 66.27,
  r: 6.27
});

function SvgOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgOther;